import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ApiService } from 'src/app/_services/api.service';
import { LanguageService } from 'src/app/_services/language.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-trendfactors',
    templateUrl: './trendfactors.component.html',
    styleUrls: ['./trendfactors.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TrendfactorsComponent implements OnInit {
  years: any;
  currentYear = null;
  trends: any;
  subscription: Subscription;
  
  constructor(private apiService: ApiService, private languageService: LanguageService) { 
    this.getTrendYears();

    this.subscription = this.languageService.currentMessage.subscribe(message => {     
      this.getTrendFactors(this.currentYear);
    })
  }

  ngOnInit() {
    
  }

  getTrendYears() {
    this.apiService.getTrendYears().subscribe(data => {
      this.currentYear = data[0].year;
      this.years = data;
      this.getTrendFactors(this.currentYear);
    })
  }

  getTrendFactors(id: any) {
    this.currentYear = id;
    this.apiService.getTrendFactors(id).subscribe(data => {
      console.log(data);
      this.trends = data;
    })
  }

}
